import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompact"
import collection from "src/engine/modules/collection/hocs/transport"

function transformData(props) {
  const { to } = props

  const {
    data,
    pending,
    model: { schema },
  } = props[to]

  /* If there's no data ot there're no schema changes, it's
   * not required */
  if (pending || !data || !schema) {
    return data
  }

  return props[to].data
}

export default config =>
  compose(
    collection(
      Object.assign(config, {
        plugins: (config.plugins || []).concat([
          {
            connect: compose(
              connect(),

              /* Convert each data properties by model */
              BaseComponent =>
                class TimeZoneTransformer extends Component {
                  constructor(...args) {
                    super(...args)
                    this.dataCache = transformData(this.props)
                  }

                  // eslint-disable-next-line camelcase
                  UNSAFE_componentWillReceiveProps(nextProps) {
                    /*
                Collection mechanism updates data only if the required collection
                or one of the target entity's model really have been changed.

                Also, I ignore all cases when data is not an array.

                Thus, I minimizes transformation count for each collection,
                because do transform only if data have changed or received.
                */
                    const { props } = this
                    if (
                      nextProps[nextProps.to].data !== props[props.to].data &&
                      nextProps[nextProps.to].data
                    ) {
                      this.dataCache = transformData(nextProps)
                    }
                  }

                  render() {
                    const { props, dataCache } = this
                    const nextProps = {
                      ...props,
                      [props.to]: {
                        ...props[props.to],
                        data: dataCache,
                      },
                    }

                    return <BaseComponent {...nextProps} />
                  }
                },
            ),
          },
        ]),
      }),
    ),
  )
